import React from 'react';
import { LoanStatusType } from '@apply/constants';
import { Column } from 'devextreme-react/data-grid';
import { formatDate } from '../../../common/SharedFunctions';

interface LoanApprovedOrNoteDateColumnParameters {
    statusId: LoanStatusType;
}

export const LoanApprovedOrNoteDateColumn: React.FC<LoanApprovedOrNoteDateColumnParameters> = ({ statusId }) => {
    const styles = {
        red: { color: 'red' },
    };

    const approvalDataCellRender = (e) => {
        return (
            <>
                {!e.data.approvalDate && 'Not Set'}
                {e.data.approvalDate && formatDate(e.data.approvalDate)}{' '}
                {e.data.daysSinceApproval > 0 && (
                    <span style={e.data.daysSinceApproval > 44 ? styles.red : null}> +{e.data.daysSinceApproval}</span>
                )}
            </>
        );
    };
    const noteDateDataCellRender = (e) => {
        return (
            <>
                {!e.data.noteDate && 'Not Set'}
                {e.data.noteDate && formatDate(e.data.noteDate)}{' '}
            </>
        );
    };

    if (statusId == LoanStatusType.Repaid || statusId == LoanStatusType.Outstanding) {
        return [
            <Column
                key='noteDate'
                dataField='noteDate'
                caption='Note Date'
                cellRender={noteDateDataCellRender}
                width={120}
                allowSorting={true}
            />,
        ];
    } else {
        return [
            <Column
                key='approvalDate'
                dataField='approvalDate'
                caption='Approved'
                cellRender={approvalDataCellRender}
                width={120}
                allowSorting={true}
            />,
        ];
    }
};
